export default __webpack_public_path__ + "assets/images/4d1b0b5b65d746783023a835a8e6d04a.svg";